export default {
    props: {
        field: {
            type: String,
            default: undefined,
            kComposite: 'field'
        }, 
        title: {
            type: String,
            default: undefined,
            kComposite: 'title'
        }, 
        format: {
            type: String,
            default: undefined,
            kComposite: 'format'
        }, 
        width: {
            type: [String, Number],
            default: undefined,
            kComposite: 'width'
        }, 
        editable: {
            type: Boolean,
            default: undefined,
            kComposite: 'editable'
        }, 
        sortable: {
            type: Boolean,
            default: undefined,
            kComposite: 'sortable'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-gantt-vue-wrapper/src/KendoGanttColumn/Columns.js